import CompactContentContainerStyles from './types';
import styles from '../styles';

const compactContentContainerStyles: CompactContentContainerStyles = styles.alignItemsBaseline;

export {
    // eslint-disable-next-line import/prefer-default-export
    compactContentContainerStyles,
};
